import React, { useState, useEffect, useCallback } from "react";

import {
    Grid,
    List,
    Button,
    ListItem,
    makeStyles,
    Checkbox,
    TableContainer,
    Table,
    TableRow,
    TableCell,
} from "@material-ui/core";
import { Link, useHistory } from "react-router-dom";
import FormHeader from "../../../../Components/FormHeader";
import DatePicker from 'react-date-picker';
import SaveIcon from '@material-ui/icons/Save';
import LocalPrintshopIcon from '@material-ui/icons/LocalPrintshop';
import CancelIcon from '@material-ui/icons/Cancel';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';


/** Third party dependencies */
import html2canvas from 'html2canvas';


/** Local dependencies & Libraries */
import Services from '../../../../Services';

import { helpers } from '../../../../helpers';

import { Imports } from '../../../../Imports';

import Snackbar from '../../../../Components/Snackbar';
import TextArea from "antd/lib/input/TextArea";
import { Divider } from "antd";
import { getImageUrl } from "../../../../helpers/getImageUrl";
import { documentSubmit } from "../../../../helpers/api";
// import { DatePicker } from "antd";
var moment = require('moment-timezone');


const {
    users,
    hr,
    Storage,
} = Services;

const {
    showSnackBar,
    getGenerator,
} = helpers;

const {
    styles: {
        displayNoneStyles: useStyles
    }
} = Imports;


const ReleaseAndDocumentation = () => {

    const storage = new Storage();

    const classes = useStyles();

    const [userData, setUserData] = useState({
        firstName: '',
        middleName: '',
        lastName: '',
        hireDate: moment(new Date())?.utc()?.format("MM-DD-YYYY"),
        position: '',
        location: '',
        pay: '',
        deptID: '',
        // jobID:'',
    })

    const [startDate, setStartDate] = useState(moment(new Date())?.utc()?.format("MM-DD-YYYY"));

    const [offerDate, setOfferDate] = useState(moment(new Date())?.utc()?.format("MM-DD-YYYY"));

    const [PDFimage, setPDFImage] = useState('');
    const [date, setDate] = useState(new Date())


    useEffect(async () => {
        let userProfile = await JSON?.parse(localStorage.getItem('user_profile'));
         
        let res = await hr.getAllApplicantsByIDApplicantLogin({ id: userProfile?.id })
        let data = {
            firstName: res?.employee?.firstName || '',
            middleName: res?.employee?.middleName || '',
            lastName: res?.employee?.lastName || '',
            ssn: res?.employee?.ssn,
            hrName: `${res?.employee?.AEmployee?.firstName || ""} ${res?.employee?.AEmployee?.lastName || ""}`
        }
        setFormData(prev => ({ ...prev, ...data }))
    }, [])

    const [error, setError] = useState('');

    const [isPosting, setPosting] = useState(false);
    const [formData, setFormData] = useState({
        firstName: '',
        middleName: '',
        lastName: '',
        authorizedEmployer: '',
        prevEmployerAddress: '',
        employerTelephone: '',
        employeeSign: "",
        employerFax: '',
        appliedForWork: false,
        prevCompany: '',
        dateToday: new Date(),
        month: '',
        year: '',
        witnessSign: '',
        ssnNumber: '',
        1: { flag: false, dateTable: new Date() },
        2: { flag: false, date: new Date() },
        3: { flag: false, date: new Date() },
        4: { flag: false, date: new Date() },
        5: { flag: false, date: new Date() },
        6: { flag: false, dateTable: new Date() },
        personPartTwo: {
            name: '',
            telephone: '',
            sign: '',
            datePerson: '',
        },
        sap: {
            name: '',
            telephone: '',
            address: '',
            date: new Date()
        }
    })


    const access = localStorage.getItem("access_jwt") || null
    const history = useHistory()

    async function submit() {

        let data = {
            prevComp: formData?.prevCompany || null,
            appliedForWork: formData?.appliedForWork || null,
            datedThis: document.getElementById("datedThis").value || null,
            month: formData?.month || null,
            year: formData?.year || null,
            employeeSign: formData?.employeeSign || null,
            authorizedEmployer: formData?.authorizedEmployer || null,
            prevEmployerAddress: formData?.prevEmployerAddress || null,
            employerTelephone: formData?.employerTelephone || null,
            employerFax: formData?.employerFax || null
        }

        documentSubmit(setPosting, data, 19, [{ height: 30, index: 0 }], access, history)
    }

    return (
        <Grid container xs={12} className="LiqForms-Container">
            <Snackbar></Snackbar>
            {/* <FormHeader/> */}
            <Grid className={isPosting ? classes.DisplayNone : 'FormsHeader'}>
                <List>
                    <ListItem>
                        <Grid className="FormMenuLogo"></Grid>
                    </ListItem>
                    <ListItem>
                        <Button onClick={submit}>
                            <SaveIcon />
                        </Button>
                    </ListItem>
                    <ListItem>
                        <Button onClick={() => window.print()}>
                            <LocalPrintshopIcon />
                        </Button>
                    </ListItem>
                    <ListItem>
                        <Button onClick={() => window.close()}>
                            <CancelIcon />
                        </Button>
                    </ListItem>
                </List>
            </Grid>
            <table id="tablePrint" className="MainTable"  >
                <tr className="w100">
                    <td className="w100">
                        <div className="capture" >
                            <table className="SecondMainTable">
                                <tr className="w100">
                                    <td className="w100">
                                        <table className="w100">
                                            <tbody className="w100">
                                                <tr className="w100 row justify-between">
                                                    {/* <td>
                                                    <div className="PreEmploymentFile">
                                                        PERSONNEL FILE
                                                    </div>
                                                </td> */}
                                                    <td className=" justify-center" style={{ width: '100%' }}>
                                                        {/* <div className="TGSLogo"></div> */}
                                                        <div className="logoImageTGS" style={{ margin: 'auto' }}></div>
                                                    </td>
                                                </tr>
                                                <tr className="w100">
                                                    <td colspan="2" className="w100 header font16 bold textCenter">Release and Documentation from Previous Employer</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                            </table>



                            <table className="" style={{ width: '80%', margin: 'auto', marginTop: '1px' }}>
                                <tbody>

                                    <tr >


                                        <td className="pt10  pb10 " style={{ fontSize: '13px' }} >Federal Department of Transportation regulations (49CFR, 40.25) require that an inquiry be made of all
                                            potential Covered Service Employees previously employed by DOT regulated employers to identify any
                                            positive test results for drugs and alcohol or other violations of DOT agency drug and alcohol testing
                                            regulations and if DOT Return To Duty requirements were completed <span style={{ fontWeight: 'bold', textDecoration: 'underLine ' }}>Failure to provide this written
                                                consent will prevent you from performing safety-sensitive functions and may result in revocation of
                                                your offer of employment</span></td>
                                    </tr>


                                </tbody>
                            </table>
                            <table className="" style={{ width: '80%', margin: 'auto', marginTop: '2px' }}>

                                <Divider style={{ der: '1px solid', marginTop: '1px' }} />
                            </table>
                            <table className="" style={{ width: '80%', margin: 'auto' }}>
                                <tbody>

                                    <tr >
                                        <td className="  mb10 pb10 " style={{ fontWeight: 'bold', fontSize: '16px' }} >Part 1 – AUTHORIZATION BY EMPLOYEE TO RELEASE INFORMATION</td>
                                    </tr>
                                    <tr >
                                        <td className="  mb10 pb10 " style={{ fontWeight: 'bold', fontSize: '16px' }} >To be Completed by:</td>
                                    </tr>


                                </tbody>
                            </table>
                            <table className="" style={{ width: '80%', margin: 'auto', marginTop: '1px' }}>
                                <tbody>

                                    <tr >
                                        <td className="mt10 pt10 mb10 pb10 " style={{ fontSize: '14px' }} >
                                            I,
                                            <input disabled value={formData?.firstName + " " + formData?.lastName} required="false" className="inp w-40 f-12" placeholder="Employee’s Name–Please Print" style={{ width: '75%' }} />

                                            here by authorize
                                            <input className="inp" style={{ width: '45%', fontSize: '12px' }} placeholder="Previous DOT-Regulated Employer" required="false"
                                                value={formData?.authorizedEmployer}
                                                onChange={(e) => setFormData(prev => ({ ...prev, authorizedEmployer: e.target.value }))} />
                                            ,
                                            <input className="inp w-40" style={{ fontSize: '12px', width: '50%' }} placeholder="Previous Employer Address(City,State,Zip)"
                                                required="false"
                                                value={formData?.prevEmployerAddress}
                                                onChange={(e) => setFormData(prev => ({ ...prev, prevEmployerAddress: e.target.value }))}
                                            />
                                            ,
                                            <input className="inp" style={{ fontSize: '12px' }}
                                                placeholder="TelephoneNumber"
                                                required="false"
                                                value={formData?.employerTelephone}
                                                onChange={(e) => setFormData(prev => ({ ...prev, employerTelephone: e.target.value }))}
                                            />
                                            ,
                                            <input className="inp" style={{ fontSize: '12px' }}
                                                placeholder="Fax Number"
                                                value={formData?.employerFax}
                                                onChange={(e) => setFormData(prev => ({ ...prev, employerFax: e.target.value }))}
                                                required="false" /></td>
                                    </tr>

                                    <tr >
                                        <td className="mt10 pt10 mb10 pb10 " style={{ fontSize: '13px' }} >To release to<span className="bold" > Safety Department,
                                            Trans-Global Solutions, Inc., 7500 FM1405, Baytown, TX
                                            77523 </span>,any positive controlled substance test results; alcohol tests with a result of .04 per cent or
                                            greater; evidence of refusal to be tested; evidence of any violations of DOT alcohol or drug
                                            regulations; information on any required substance abuse professional evaluation; determination
                                            of need for assistance and compliance with these recommendations. I request that such records
                                            be released immediately.</td>
                                    </tr>
                                    <Divider style={{ der: '1px dashed', marginTop: '1px', marginBottom: '1px' }} />
                                    <tr >
                                        <td className="  mb10 pb10 " style={{ fontSize: '13px' }} >
                                            <Checkbox checked={formData?.appliedForWork} onChange={() => setFormData(prev => ({ ...prev, appliedForWork: prev?.appliedForWork ? false : true }))} />
                                            I have not worked (or applied to work) in a safety sensitive position for any DOT-Regulated
                                            employer within the last two years prior to my application for or transfer to a safety sensitive
                                            position with
                                            <input className="inp" style={{ fontSize: '13px' }}
                                                value={formData?.prevCompany}
                                                required={true}
                                                onChange={(e) => setFormData(prev => ({ ...prev, prevCompany: e.target.value }))} />
                                            or with Trans-Global Solutions, Inc.</td>
                                    </tr>
                                    <tr>
                                        <td className=" pt10 mb10 pb10 " style={{ fontSize: '13px' }} >Dated this
                                            <input className="inp" id="datedThis" /> day of <input className="inp"
                                                value={formData?.month}
                                                onChange={(e) => setFormData(prev => ({ ...prev, month: e.target.value }))} />
                                            ,<br />20
                                            <input
                                                value={formData?.year}
                                                onChange={(e) => setFormData(prev => ({ ...prev, year: e.target.value }))}
                                                className="inp" />
                                             SSN Number
                                            <input className="inp"
                                                value={`*****${formData?.ssn?.slice(-4)}`}
                                                disabled
                                                // ssn: `***${ssn?.slice(-6

                                                onChange={(e) => setFormData(prev => ({ ...prev, ssnNumber: e.target.value }))}
                                            /></td>
                                    </tr>
                                    <Divider style={{ der: '1px dashed', marginTop: '20px', marginBottom: '20px' }} />
                                    <tr>
                                        <td colspan="2" className="w100 header font16 bold textCenter" style={{ textDecoration: 'underLine ' }}>RELEASE AUTHORIZATION</td>
                                    </tr>
                                    <tr >
                                        <td className="mt10 pt10 mb10 pb10 " style={{ fontSize: '13px' }} >
                                            With my signature below, I am authorizing you to release any information in regards to any
                                            alcohol and/or controlled substance program and/or testing to which I was a party to while in your
                                            employ, acting as your agent, under contract with you, or acting as your representative in any
                                            capacity during the preceding two years from the date listed above.</td>
                                    </tr>
                                    <tr >
                                        <td className="mt10 pt10 mb10 pb10 " style={{ fontSize: '13px' }} > Authorization to release will expire once the requested information has been sent to the company
                                            named by this release. I hereby release Trans-Global Solutions, Inc., its affiliates and the
                                            previous employer supplying the requested information, from any and all liability in connection
                                            with obtaining and using such information. This authorization may not be used to provide
                                            information to any other persons.</td>
                                    </tr>
                                    <tr style={{ border: "2px solid lightblue" }}>
                                        <td className="mt10 pt10 mb10 pb10 " style={{ fontSize: '13px' }} ><span className="bold">Signature of Employee</span>
                                            <input
                                                // value={formData?.firstName + " " + formData?.lastName}
                                                onChange={(e) => setFormData(prev => ({ ...prev, employeeSign: e.target.value }))}
                                                className="inp w-100 signatureClass"
                                                id="signatureEmployee"
                                                required={true} /></td>
                                    </tr>
                                    {/* <tr >
                                        <td className=" mb10 pb10 " style={{ fontSize: '13px' }} ><span className="bold" style={{ width: '10px' }}>Witness</span>
                                            <input className="inp w-100 signatureClassOtherr"
                                                value={formData?.hrName}
                                                disabled
                                            // onChange={(e) => setFormData(prev => ({ ...prev, witnessSign: e.target.value }))}    
                                            /></td>
                                    </tr> */}

                                </tbody>
                            </table>
                            {/* <table style={{ width: '80%', margin: 'auto' }}>
                                <tbody>
                                    <tr >
                                        <td className="mt10 pt10 mb10 pb10 " style={{ fontSize: '13px' }} ><span className="bold">Employee Name</span>
                                            <input className="inp w-100"
                                                value={formData?.firstName + " " + formData?.lastName}
                                                // onChange={(e) => setFormData(prev => ({ ...prev, dateToday: e.target.value }))} 
                                                disabled
                                            /></td>
                                        <td className="mt10 pt10 mb10 pb10 " style={{ fontSize: '13px' }} ><span className="bold">SSN Number</span>
                                            <input
                                                // value={formData?.ssnNumber}
                                                value={`*****${formData?.ssn?.slice(-4)}`}
                                                disabled
                                                onChange={(e) => setFormData(prev => ({ ...prev, ssnNumber: e.target.value }))}
                                                className="inp w-100" /></td>
                                    </tr>


                                </tbody>
                            </table> */}


                            <Divider style={{ der: '1px dashed', marginTop: '20px', marginBottom: '20px' }} />

                        </div>
                        {/* +++++++++++++++++++++++++++++++++++++++++++++++++++++++ */}
                        <div className="capture" >
                            <br />
                            <br />
                            <table style={{ width: '80%', margin: 'auto', marginTop: '1px' }}>
                                <tbody>
                                    <tr>
                                        <td className=" mb10 pb10 " style={{ fontSize: '13px' }} ><span className="bold" style={{ width: '10px' }}>Witness</span>
                                            <input className="inp w-100 signatureClassOtherr"
                                                value={formData?.hrName}
                                                disabled
                                            // onChange={(e) => setFormData(prev => ({ ...prev, witnessSign: e.target.value }))}    
                                            /></td>
                                    </tr>
                                </tbody>
                            </table>
                            <table style={{ width: '80%', margin: 'auto' }}>
                                <tbody>
                                    <tr >
                                        <td className="mt10 pt10 mb10 pb10 " style={{ fontSize: '13px' }} ><span className="bold">Employee Name</span>
                                            <input className="inp w-100"
                                                value={formData?.firstName + " " + formData?.lastName}
                                                // onChange={(e) => setFormData(prev => ({ ...prev, dateToday: e.target.value }))} 
                                                disabled
                                            /></td>
                                        <td className="mt10 pt10 mb10 pb10 " style={{ fontSize: '13px' }} ><span className="bold">SSN Number</span>
                                            <input
                                                // value={formData?.ssnNumber}
                                                value={`*****${formData?.ssn?.slice(-4)}`}
                                                disabled
                                                onChange={(e) => setFormData(prev => ({ ...prev, ssnNumber: e.target.value }))}
                                                className="inp w-100" /></td>
                                    </tr>


                                </tbody>
                            </table>
                            <div className="pageBreak" style={{ border: "dotted 1px white" }}>
                                <table style={{ width: '80%', margin: 'auto' }} >
                                    <tbody>
                                        <tr>
                                            <td className="bold " style={{ marginBottom: '30px' }}  >Part 2 – TO BE COMPLETED BY PREVIOUS EMPLOYER</td>
                                        </tr>
                                    </tbody>
                                </table>


                                <table style={{ width: '80%', margin: 'auto', marginTop: "20px!important" }}>
                                    <tbody>
                                        <tr style={{ marginTop: '10px' }}>
                                            <td className=" bold" style={{ width: '5%' }}>#</td>

                                            <td className=" bold" style={{ width: '55%' }}>IN THE LAST TWO YEARS:</td>
                                            <td className=" bold" style={{ width: '5%' }}>NO</td>
                                            <td className=" bold" style={{ width: '10%' }}>YES</td>
                                            <td className=" bold" style={{ width: '10%' }}>DATE</td>


                                        </tr>
                                        <tr style={{ padding: '10px', marginBottom: '20px' }}>
                                            <td contenteditable={false} className="" >1.</td>
                                            <td className="" >Have you employed (or considered for employment) the above-named applicant in a safety-sensitive position?</td>
                                            <td className="">
                                                <input type="checkbox" id="noCheckbox"
                                                    onChange={() => setFormData(prev => ({ ...prev, ['1']: { ...prev['1'], flag: false } }))}
                                                    checked={formData['1']?.flag}
                                                    disabled
                                                />
                                            </td>
                                            <td className="">
                                                <input type="checkbox" id="yesCheckbox"
                                                    onChange={() => setFormData(prev => ({ ...prev, ['1']: { ...prev['1'], flag: true } }))}
                                                    checked={formData['1']?.flag}
                                                    disabled />
                                            </td>
                                            <td contenteditable="false" className="" >
                                                {/* <DatePicker
                                            onChange={(date) => setFormData(prev => ({ ...prev, ['1']: { ...prev['1'], date } }))}
                                            value={formData['1']?.date}
                                            id="offerDate"
                                            className="datePickerReact bb"
                                                disabled
                                        /> */}
                                                <input className="inp" disabled />
                                            </td>

                                        </tr>
                                        <tr>
                                            <td contenteditable={false} className="" >2.</td>
                                            <td className="f-13" >Has this person had a DOT breath alcohol test with<br /> a result of .04 percent or greater?</td>
                                            <td className="">
                                                <input type="checkbox" id="noCheckbox"
                                                    onChange={() => setFormData(prev => ({ ...prev, ['2']: { ...prev['2'], flag: false } }))}
                                                    checked={formData['2']?.flag}
                                                    disabled />
                                            </td>
                                            <td className="">
                                                <input type="checkbox" id="yesCheckbox"
                                                    onChange={() => setFormData(prev => ({ ...prev, ['2']: { ...prev['2'], flag: true } }))}
                                                    checked={formData['2']?.flag}
                                                    disabled />
                                            </td>
                                            <td contenteditable="false" className="" >
                                                {/* <DatePicker
                                            onChange={(date) => setFormData(prev => ({ ...prev, ['2']: { ...prev['2'], date } }))}
                                            value={formData['2']?.date}
                                            // value={formData?.personPartTwo?.datePerson}
                                            id="offerDate"
                                            className="datePickerReact bb"

                                        /> */}
                                                <input className="inp" disabled />
                                            </td>



                                        </tr>
                                        <tr className="mt10">
                                            <td contenteditable={false} className="" >3.</td>
                                            <td className="mt10 f-13" >Has this person tested positive for controlled substances in a DOT drug test?</td>
                                            <td className="">
                                                <input type="checkbox" id="noCheckbox"
                                                    onChange={() => setFormData(prev => ({ ...prev, ['3']: { ...prev['3'], flag: false } }))}
                                                    checked={formData['3']?.flag}
                                                    disabled />
                                            </td>
                                            <td className="">
                                                <input type="checkbox" id="yesCheckbox"
                                                    onChange={() => setFormData(prev => ({ ...prev, ['3']: { ...prev['3'], flag: true } }))}
                                                    checked={formData['3']?.flag}
                                                    disabled />
                                            </td>
                                            <td contenteditable="false" className="" >
                                                {/* <DatePicker
                                            onChange={(date) => setFormData(prev => ({ ...prev, ['3']: { ...prev['3'], date } }))}
                                            value={formData['3']?.date}
                                            // value={formData?.personPartTwo?.datePerson}
                                            id="offerDate"
                                            className="datePickerReact bb"

                                        /> */}
                                                <input className="inp" disabled />
                                            </td>

                                        </tr>
                                        <tr className="mt10">
                                            <td contenteditable={false} className="" >4.</td>
                                            <td className="mt10 f-13" >Has this person refused a DOT alcohol or drug test (including verified adulterated or substituted drug test results)?</td>
                                            <td className="">
                                                <input type="checkbox" id="noCheckbox"
                                                    onChange={() => setFormData(prev => ({ ...prev, ['4']: { ...prev['4'], flag: false } }))}
                                                    checked={formData['4']?.flag}
                                                    disabled />
                                            </td>
                                            <td className="">
                                                <input type="checkbox" id="yesCheckbox"
                                                    onChange={() => setFormData(prev => ({ ...prev, ['4']: { ...prev['4'], flag: true } }))}
                                                    checked={formData['4']?.flag}
                                                    disabled />
                                            </td>
                                            <td contenteditable="false" className="" >
                                                {/* <DatePicker
                                            onChange={(date) => setFormData(prev => ({ ...prev, ['4']: { ...prev['4'], date } }))}
                                            value={formData['4']?.date}
                                            // value={formData?.personPartTwo?.datePerson}
                                            id="offerDate"
                                            className="datePickerReact bb"

                                        /> */}
                                                <input className="inp" disabled />
                                            </td>

                                        </tr>
                                        <tr className="mt10">
                                            <td contenteditable={false} className="" >5.</td>
                                            <td className="mt10 f-13" >Has this person had other violations of DOT agency drug and alcohol testing requirements?</td>
                                            <td className="">
                                                <input type="checkbox" id="noCheckbox"
                                                    onChange={() => setFormData(prev => ({ ...prev, ['5']: { ...prev['5'], flag: false } }))}
                                                    checked={formData['5']?.flag}
                                                    disabled />
                                            </td>
                                            <td className="">
                                                <input type="checkbox" id="yesCheckbox"
                                                    onChange={() => setFormData(prev => ({ ...prev, ['5']: { ...prev['5'], flag: true } }))}
                                                    checked={formData['5']?.flag}
                                                    disabled />
                                            </td>
                                            <td contenteditable="false" className="" >
                                                {/* <DatePicker
                                            onChange={(date) => setFormData(prev => ({ ...prev, ['5']: { ...prev['5'], date } }))}
                                            value={formData['5']?.date}

                                            id="offerDate"
                                            className="datePickerReact bb "

                                        /> */}
                                                <input className="inp" disabled />
                                            </td>

                                        </tr>
                                        <tr>
                                            <td contenteditable={false} className="" >6.</td>
                                            <td className="mt10 f-13" >If YES for any question 2 through 5, did this person meet DOT Return To Duty requirements?</td>
                                            <td className="">
                                                <input type="checkbox" id="noCheckbox"
                                                    onChange={() => setFormData(prev => ({ ...prev, ['6']: { ...prev['6'], flag: false } }))}
                                                    checked={formData['6']?.flag}
                                                    disabled />
                                            </td>
                                            <td className="">
                                                <input type="checkbox" id="yesCheckbox"
                                                    onChange={() => setFormData(prev => ({ ...prev, ['6']: { ...prev['6'], flag: true } }))}
                                                    checked={formData['6']?.flag}
                                                    disabled />
                                            </td>
                                            <td contenteditable="false" >
                                                {/* <DatePicker
                                            popperPlacement='bottom'
                                            onChange={(date) => setFormData(prev => ({ ...prev, ['6']: { ...prev['6'], date } }))} 
                                            value={formData['6']?.date}
                                            // value={formData?.personPartTwo?.datePerson}
                                            id="offerDate"
                                            className=" datePickerReact bb"
                                            

                                        /> */}
                                                <input className="inp" disabled />
                                            </td>
                                        </tr>
                                    </tbody>

                                </table>
                            </div>
                            <table style={{ width: '70%', margin: 'auto', marginTop: '20px' }}>
                                <tbody>
                                    <tr>
                                        <td className="f-13" >If<span className="bold"> YES</span> to any of the above questions (2 through 5), please attach any
                                            documentation relating to the Substance Abuse Professional (SAP) evaluation,
                                            determination and compliance, and provide information requested below.</td>
                                    </tr>
                                </tbody>
                            </table>
                            <table className="" style={{ width: '80%', margin: 'auto', marginTop: '20px' }}>
                                <tbody>

                                    <tr >
                                        <td className="mt10 pt10 mb10 pb10 " style={{ fontSize: '14px' }} >SAP Name
                                            <input className="inp w-40 f-12"
                                                value={formData?.sap?.name}
                                                disabled
                                                onChange={(e) => setFormData(prev => ({ ...prev, sap: { ...prev?.sap, name: e.target.value } }))} />

                                            SAP Telephone  <input
                                                className="inp f-12"
                                                disabled
                                                value={formData?.sap?.telephone}
                                                onChange={(e) => setFormData(prev => ({ ...prev, sap: { ...prev?.sap, telephone: e.target.value } }))} />


                                        </td>
                                    </tr>





                                </tbody>
                            </table>
                            <table style={{ width: '80%', margin: 'auto', marginTop: '20px' }}>
                                <tbody>
                                    <tr >
                                        <td className="mt10 pt10 mb10 pb10 " style={{ fontSize: '13px' }} ><span className="">SAP Address</span>
                                            <input className="inp"
                                                disabled
                                                placeholder=""
                                                value={formData?.sap?.address}
                                                onChange={(e) => setFormData(prev => ({ ...prev, sap: { ...prev?.sap, address: e.target.value } }))} /> </td>
                                    </tr>


                                </tbody>
                            </table>
                            <table style={{ width: '80%', margin: 'auto', marginTop: '20px' }}>
                                <tbody>
                                    <tr >
                                        <td className="mt10 pt10 mb10 pb10 " style={{ fontSize: '13px' }} ><span className="">Name/Title of person completing Part 2:</span> <input className="inp"
                                            disabled
                                            value={formData?.personPartTwo?.name}
                                            onChange={(e) => setFormData(prev => ({ ...prev, personPartTwo: { ...prev?.personPartTwo, name: e.target.value } }))} /> </td>


                                    </tr>

                                    {/* border: '3px solid lightblue' */}
                                </tbody>
                            </table>
                            <table style={{ width: '80%', margin: 'auto', marginTop: '20px' }}>
                                <tbody>
                                    <tr >
                                        <td className="mt10 pt10 mb10 pb10 " style={{ fontSize: '13px' }} ><span className="">Signature of person completing part 2: </span> <input className="inp signatureClass f20"
                                            value={formData?.personPartTwo?.sign}
                                            disabled
                                            onChange={(e) => setFormData(prev => ({ ...prev, personPartTwo: { ...prev?.personPartTwo, sign: e.target.value } }))} /></td>


                                    </tr>


                                </tbody>
                            </table>
                            <table style={{ width: '80%', margin: 'auto', marginTop: '20px' }}>
                                <tbody>

                                    <tr >
                                        <td className="mt10 pt10 mb10 pb10 " style={{ fontSize: '13px' }} ><span className="">Telephone </span>
                                            <input className="inp w-100 "
                                                disabled
                                                value={formData?.personPartTwo?.telephone}
                                                onChange={(e) => setFormData(prev => ({ ...prev, personPartTwo: { ...prev?.personPartTwo, telephone: e.target.value } }))} /></td>
                                        <td className=" pt10 mb10 pb10 " style={{ fontSize: '13px' }} ><span className="">Date </span>

                                            {/* <DatePicker
                                            onChange={(e) => setFormData(prev => ({ ...prev, personPartTwo: { ...prev?.personPartTwo, datePerson: e } }))}

                                            value={formData?.personPartTwo?.datePerson}
                                            id="offerDate"
                                            className="datePickerReact mm w-80"

                                        /> */}
                                            <input className="inp" disabled />
                                        </td>

                                    </tr>


                                </tbody>
                            </table>


                            <table style={{ width: '80%', margin: 'auto', marginTop: '20px' }}>
                                <tbody className="w100">
                                    <tr className="w100">
                                        <td className="w100 bold f-13" style={{ textAlign: 'center' }} >Please note: Pursuant to 49CFR, Parts 653.75(f) and 654.55(f) require that previous employers must
                                            provide, in a timely manner, information regarding violations found in Parts 653.71 and 654.51.
                                        </td>



                                    </tr>
                                </tbody>
                            </table>
                            <table className="w100 mt20">
                                <tbody>
                                    <tr> </tr>
                                </tbody>
                            </table>

                        </div>
                    </td>
                </tr>
            </table>
        </Grid >
    );

}
export default ReleaseAndDocumentation;